module.exports = __webpack_public_path__ + "blogpage_design_webdesign_website_digitalfactory_griddesign.jpg?6f813726f378edca6397a09627110ab3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/blogpage_design_webdesign_website_digitalfactory_griddesign.jpg
// module id = 44
// module chunks = 0